<template>
  <ul>
    <li>
      <!-- pc view -->
      <div id="oblea" v-if='!mobileView' class="fh lc" @click="clickOblea" style="width: 190px; height: 50px; border: 1px solid #dddddd;  background: #ffffff; 
           margin-bottom: 15px; box-shadow: 2px 2px 4px #dddddd; -webkit-box-shadow: 2px 2px 4px #dddddd; -moz-box-shadow: 2px 2px 4px #dddddd;">
        <div class="fh cc" style="width:60px; height: 40px" >
          <img :src="imagenProducto" style="width: 40px;height:40px" /> 
        </div>
        <div class="fh lc" style="width: 130px; height: 40px; font-size: 10px; font-weight: 410;color: #5c666f" >
          <div>{{item.Titulo}}</div>
        </div>
      </div>
      <!-- mobile view -->
      <div id="oblea" v-if='mobileView' class="fh lc" @click="clickOblea" style="width: 150px; height: 50px; border: 1px solid #dddddd;  background: #ffffff; 
           margin-bottom: 15px;margin-right: 20px; box-shadow: 2px 2px 4px #dddddd; -webkit-box-shadow: 2px 2px 4px #dddddd; -moz-box-shadow: 2px 2px 4px #dddddd;">
        <div class="fh cc" style="width:60px; height: 40px" >
          <img :src="imagenProducto" style="width: 40px;height:40px" /> 
        </div>
        <div class="fh lc" style="width: 130px; height: 40px; font-size: 10px; font-weight: 410;color: #5c666f" >
          <div>{{item.Titulo}}</div>
        </div>
      </div>
    </li>
  </ul>
</template>

 
<script>
import axios from 'axios'

  export default {
    name: 'item-descuentoHome',
    props: ['item'],

    data() {
      return {
        mobileView:false    
      }
    },  

    watch: {
      item: {
        immediate: true,
        handler  () {
        }
      }
    },

    computed: {
        imagenProducto() {
          if ((this.item.Imagen != null) && (this.item.Imagen.length > 0)) {
            return this.item.Imagen
          }
          else {
            return '/dist/placeholder-producto.png'
          }
        } 
    },


    methods: {

      onResize() {
        if (window.innerWidth > 600) 
        {
           this.mobileView=false;
        }
        else 
        {
           this.mobileView=true;
        }
      },

      clickOblea () {
         this.$router.push({ name: 'Descuentos' });
      }

    },

    mounted() {
      this.onResize()
    },

    created() {
     window.addEventListener('resize', this.onResize)
    },

    beforeDestroy() {
     window.removeEventListener('resize', this.onResize)
    }

  }
</script>


<style scoped>

  * {
   margin:  0;
   padding: 0;
  }
        
  li {
   display: block;
   text-decoration: none;
  }

#oblea:hover{
    cursor: pointer;
  }      
        
        
</style>


// WEBPACK FOOTER //
// src/components/views/home/itemDescuentoHome.vue